import { dealTokens } from './designTokens';

// Shared visual adapter for data-heavy Deal surfaces. Keep this dependency on
// dealTokens only so reports, dashboards and list shells cannot drift toward a
// feature-specific palette.
export const listTokens = Object.freeze({
  primary: dealTokens.color.primary,
  accent: dealTokens.color.primary,
  success: dealTokens.color.success,
  danger: dealTokens.color.danger,
  warning: dealTokens.color.warning,
  info: dealTokens.color.info,
  bg: dealTokens.color.canvas,
  cardBg: dealTokens.color.surface,
  border: dealTokens.color.border,
  textPrimary: dealTokens.color.text,
  textMuted: dealTokens.color.textMuted,
  textLight: dealTokens.color.textSubtle,
});

export const listViewTokens = Object.freeze({
  border: listTokens.border,
  primary: listTokens.primary,
  textMuted: listTokens.textLight,
  cardBg: listTokens.cardBg,
  hoverBg: listTokens.bg,
});

export const badgeTokens = Object.freeze({
  textMuted: listTokens.textMuted,
  success: listTokens.success,
  warning: listTokens.warning,
  danger: listTokens.danger,
  info: listTokens.info,
  accentDark: listTokens.primary,
});

// Recharts/ECharts views consume the same semantic roles. Series are neutral by
// default; a view may use `highlight` for at most one focused series. `up` and
// `down` belong to delta/status indicators, not decoration.
export const chartTheme = Object.freeze({
  axis: dealTokens.color.text,
  grid: dealTokens.color.border,
  series: Object.freeze([dealTokens.color.textMuted, dealTokens.color.textSubtle]),
  highlight: dealTokens.color.primary,
  up: dealTokens.color.success,
  down: dealTokens.color.danger,
});

export default listTokens;
